import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import loginStyle from './Login.module.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export default function Login() {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('')

    const apiurl = process.env.REACT_APP_SERVER_URL;
    const navigate = useNavigate();

    // handle login to check the employee or admin and token logic code
    const handleLogin = async () => {
        if (!apiurl) {
            setError("api is not working")
            return;
        }
        try {
            const res = await fetch(`${apiurl}/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password })
            })

            if (!res) {
                setError("Login Failed")
                setTimeout(() => {
                    setError("")
                }, 1000);
                return;
            }

            const data = await res.json();
            if (res.ok) {
                setMessage("Login Successful");

                // Save token + expiry
                const expiryTime = Date.now() + 30 * 60 * 1000;
                localStorage.setItem("token", data.token);
                localStorage.setItem("user", JSON.stringify(data.user));
                localStorage.setItem("tokenExpiry", expiryTime);

                // login expiry test
                // const expiryTime = Date.now() + 10 * 1000; // for testing
                // localStorage.setItem("token", data.token);
                // localStorage.setItem("user", JSON.stringify(data.user));
                // localStorage.setItem("tokenExpiry", expiryTime);

                // Navigate by role...
                if (data.user.role === "Admin") {
                    navigate(`/admin-dashboard/${data.user.employeeId}`);
                } else if (data.user.role === "Manager") {
                    navigate(`/admin-dashboard/${data.user.employeeId}`);
                } else if (data.user.role === "HR") {
                    navigate(`/admin-dashboard/${data.user.employeeId}`);
                } else if (data.user.role === "Employee") {
                    navigate(`/employee-dashboard/${data.user.employeeId}`);
                } else {
                    navigate("/login");
                }

            } else {
                setError(data.message || "Login failed");
                setTimeout(() => {
                    setError("")
                }, 2000);
            }
        }
        catch (err) {
            setError(err.message);
            setTimeout(() => {
                setError()
            }, 1000);
        }
    };

    return (
        <>
            <div className={loginStyle.loginPage}>
                <div className='d-flex justify-content-center align-items-center vh-100'>
                    <div className={`${loginStyle.login} shadow`}>
                        <div className="container">

                            {/* form containing thhe logina nd password */}
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault(); // prevents page reload
                                    handleLogin();
                                }}
                            >
                                {/*message and error component */}
                                {message && <p className="text-success text-center">{message}</p>}
                                {error && <p className="text-danger text-center">{error}</p>}

                                {/* Welcome Msg  */}
                                <p className={`${loginStyle.heading} text-center pt-3`}>Welcome to PeoplePulse!</p>
                                <p className={`${loginStyle.text} text-center pb-3`}>Sign in to your Account</p>

                                {/* logic card code */}
                                <div className={loginStyle.inputBox}>

                                    {/* Email Field */}
                                    <input
                                        type="text"
                                        className={`mb-4 ${loginStyle.input}`}
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Password Field */}
                                <div className={`${loginStyle.inputBox} position-relative`}>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        className={`mb-2 ${loginStyle.input}`}
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        style={{
                                            paddingRight: "40px", // space for icon
                                        }}
                                    />

                                    <FontAwesomeIcon
                                        icon={showPassword ? faEyeSlash : faEye}
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="password-toggle-icon"
                                    />

                                    <style jsx>{`
        .password-toggle-icon {
          position: absolute;
          right: 16px;
          top: 40%;
          transform: translateY(-50%);
          cursor: pointer;
          color: gray;
          font-size: 1.1rem;
          transition: color 0.2s ease, transform 0.2s ease;
        }

        .password-toggle-icon:hover {
          color: #007bff;
          transform: translateY(-50%) scale(1.1);
        }

        @media (max-width: 576px) {
          .password-toggle-icon {
            right: 10px;
            font-size: 0.95rem;
          }
        }
      `}</style>
                                </div>
                                <div className="row ">
                                    <button
                                        type="submit"
                                        className={`${loginStyle.loginBtn} btn btn-sm btn-outline-primary mt-4 mb-3 mx-auto`}
                                    >
                                        Login
                                    </button>
                                </div>
                            </form>

                            {/* sign up button */}
                            <p className={`${loginStyle.text} text-center `}>
                                New Register? Please <Link to='/signup'>signup</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
